"use client";

import { useTranslation } from "react-i18next";

import Button from "@/shared/ui/components/button";
import List, { ListItem } from "@/shared/ui/components/list";
import Box from "@/shared/ui/components/box";
import Modal from "@/shared/ui/components/modal";
import { SupportIcon } from "@/shared/ui/icons/support-icon";
import { RefundIcon } from "@/shared/ui/icons/refund-icon";
import { RewardsIcon } from "@/shared/ui/icons/rewards-icon";

interface BuyerProtectionModalProps {
  isOpen: boolean;
  isClosing: boolean;
  onClose: () => void;
}

export function BuyerProtectionModal({
  isOpen,
  isClosing,
  onClose,
}: BuyerProtectionModalProps) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <Modal
      onClose={onClose}
      showCloseButton
      stickyFooter={(close) => (
        <Button size="large" onClick={close} className="w-full">
          {t("buyer_protection.got_it")}
        </Button>
      )}
    >
      <div
        className="px-6 pb-2 pt-6 space-y-6 overflow-y-auto flex-1 min-h-0"
        data-is-closing={isClosing ? "true" : "false"}
      >
        <div className="flex mb-4 justify-center">
          <div className="bg-purple-600 w-fit h-[23px] text-white px-2 py-1 rounded-[6px] text-[10px] font-bold">
            {t("buyer_protection.badge")}
          </div>
        </div>
        <div>
          <h1 className="text-[24px] text-center font-semibold text-gray-900 mb-2">
            {t("buyer_protection.title")}
          </h1>
          <p className="text-base text-[#585B7A] mb-8 text-center">
            {t("buyer_protection.description")}
          </p>
        </div>
        <Box className="space-y-4">
          <List>
            <ListItem
              icon={<SupportIcon />}
              title={t("buyer_protection.items.support.title")}
            >
              {t("buyer_protection.items.support.description")}
            </ListItem>
            <ListItem
              icon={<RefundIcon />}
              title={t("buyer_protection.items.refund.title")}
            >
              {t("buyer_protection.items.refund.description")}
            </ListItem>
            <ListItem
              icon={<RewardsIcon />}
              title={t("buyer_protection.items.rewards.title")}
            >
              {t("buyer_protection.items.rewards.description")}
            </ListItem>
          </List>
        </Box>
      </div>
    </Modal>
  );
}
